import { useMutation, useQuery } from '@apollo/client';

import {
  Center,
  Spinner,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
  HStack,
  Button,
  useDisclosure,
  useToast,
  VStack,
  Badge,
} from '@chakra-ui/react';

import { useState } from 'react';

import moment from 'moment';

import { useUser } from '../../../../Context';

import {
  DELETE_NEWSLETTER,
  QUERY_PUBLISHED_NEWSLETTERS,
} from '../../../../Queries';
import { AddNewsletterModal, EditNewsletterModal } from '.';

const DOC_TYPE_LABELS = {
  BOARD_MINUTES: 'Board Minutes',
  FINANCIAL_STATEMENTS: 'Financial',
  MEMBERSHIP_MATERIALS: 'Membership',
  OTHER_DOCUMENTS: 'Other',
};

export const Newsletters = () => {
  const { user } = useUser();
  const toast = useToast();

  const { loading: newslettersLoading, error: newslettersError, data: newslettersData } = useQuery(QUERY_PUBLISHED_NEWSLETTERS, {
    skip: !user,
    errorPolicy: 'all',
  });

  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isEditOpen, onOpen: onEditOpen, onClose: onEditClose } = useDisclosure();

  const [openEditNewsletter, setOpenEditNewsletter] = useState(null);
  const [deletingId, setDeletingId] = useState(null);

  const [deleteNewsletter, { loading: deleteLoading }] = useMutation(DELETE_NEWSLETTER, {
    refetchQueries: [QUERY_PUBLISHED_NEWSLETTERS],
    onCompleted: () => {
      toast({
        title: 'Document deleted.',
        status: 'success',
        duration: 4000,
        isClosable: true,
      });
      setDeletingId(null);
    },
    onError: () => {
      toast({
        title: 'Failed to delete document.',
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
      setDeletingId(null);
    }
  });

  const handleDelete = (newsletterId) => {
    if (window.confirm('Are you sure you want to delete this document?')) {
      setDeletingId(newsletterId);
      deleteNewsletter({ variables: { newsletter_id: newsletterId } });
    }
  };

  return (
    newslettersLoading ? (
      <Center>
        <Spinner />
      </Center>
    ) : (
      <>
        <VStack>
          <Button onClick={onOpen}>Add New</Button>
          <TableContainer>
            <Table variant='simple'>
              <TableCaption>Member Documents</TableCaption>
              <Thead>
                <Tr>
                  <Th>Document Name</Th>
                  <Th>Type</Th>
                  <Th>Published By</Th>
                  <Th>Date</Th>
                  <Th>Actions</Th>
                </Tr>
              </Thead>
              <Tbody>
                {newslettersData?.queryPublishedNewsletters?.newsletters?.map((newsletter) => (
                  <Tr key={newsletter?.newsletter_id}>
                    <Td>
                      <Button
                        variant="link"
                        onClick={() => {
                          onEditOpen();
                          setOpenEditNewsletter(newsletter);
                        }}
                      >
                        {newsletter?.newsletter_details?.newsletter_name}
                      </Button>
                    </Td>
                    <Td>
                      <Badge colorScheme="teal" fontSize="xs">
                        {DOC_TYPE_LABELS[newsletter?.newsletter_details?.document_type] || 'Unknown'}
                      </Badge>
                    </Td>
                    <Td>{newsletter?.newsletter_details?.newsletter_published_by}</Td>
                    <Td>{newsletter?.newsletter_details?.newsletter_date ? moment.utc(newsletter?.newsletter_details?.newsletter_date * 1000).format('MM/DD/YYYY') : 'N/A'}</Td>
                    <Td>
                      <Button
                        size="sm"
                        colorScheme="red"
                        variant="outline"
                        isLoading={deletingId === newsletter?.newsletter_id}
                        onClick={() => handleDelete(newsletter?.newsletter_id)}
                      >
                        Delete
                      </Button>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </VStack>
        <AddNewsletterModal isOpen={isOpen} onClose={onClose} />
        <EditNewsletterModal isOpen={isEditOpen} onClose={onEditClose} openEditNewsletter={openEditNewsletter} setOpenEditNewsletter={setOpenEditNewsletter} />
      </>
    )
  )
};
